var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShieldHalved = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.0003 1.5a.83.83 0 0 1 .3421.074l4.8074 2.0399c.5616.2374.9803.7914.9778 1.4603-.0128 2.5326-1.0544 7.1664-5.4533 9.2726a1.559 1.559 0 0 1-1.348 0c-4.3988-2.1062-5.4405-6.74-5.4532-9.2726-.0026-.6689.4161-1.2229.9778-1.4603L7.6608 1.574a.81.81 0 0 1 .3395-.074m0 1.7054v9.6505c3.5232-1.7055 4.4704-5.4814 4.4933-7.746z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShieldHalved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shield-halved.976cd629f2d3868da1b7e6a00bba0804.svg";